import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import Iconify from "../../layouts/components/iconify/iconify";
import Tooltip from "../../components/ui/tooltip/Tooltip";
import CenterModel from "../../components/ui/centerModel/CenterModel";
import { useDeleteTimesheetDetailMutation, useLazyGetTimeSheetLogListByTaskIdQuery } from "../../app/services/timeSheetLogAPI";
import formatDate from "../../lib/formatDate";
import formatTime from "../../lib/formatTime";
import "./TimeLog.scss";
import SwalAlert from "../../services/swalService/SwalService";
import ToastService from "../../services/toastService/ToastService";
import TaskTimeLog from "../editmytask/features/taskDetail/feature/taskTimeLog/TaskTimeLog";

const subActivityClassMap = {
  "coding": "coding",
  "impect analysis": "impectanalysis",
  "bug fixing": "bugfixing",
  "code review": "codereview",
  "r & d": "research",
  "ui design": "uidesign",
  "code review fix": "codereviewfix",
  "testing": "testing",
  "task discussion": "taskdiscussion",
  "configuration": "configuration"
};

const TimeLog = ({ taskId, projectId, onSuccess }, ref) => {

  const [listData, setListData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState(false);

  const [getTimeSheetLogListByTaskId, {
    isFetching: isGetTimeSheetLogListByTaskIdFetching,
    isSuccess: isGetTimeSheetLogListByTaskIdSuccess,
    data: isGetTimeSheetLogListByTaskIdData,
  },] = useLazyGetTimeSheetLogListByTaskIdQuery();

  const [deleteTimesheetDetail, {
    isSuccess: isdeleteTimesheetDetailSuccess,
    data: deleteTimesheetDetailData
  }] = useDeleteTimesheetDetailMutation();

  const { confirm } = SwalAlert();

  const handleDeleteClick = (timesheetDetailId) => {
    confirm(
      "Delete?",
      "Are you sure you want to Delete?",
      "Delete",
      "Cancel"
    ).then((confirmed) => {
      if (confirmed) {
        deleteTimesheetDetail(timesheetDetailId)
      }
    });
  };

  const handleEditClick = (data) => {
    setEditData(data);
    setModalOpen(true);
    setIsEdit(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setIsEdit(false);
    setEditData(false);
  };

  const handleSuccess = () => {
    getTimeSheetLogListByTaskId(taskId);
    closeModal();
  };

  const generateSubActivityColor = (subActivity) => {
    if (!subActivity || typeof subActivity !== 'string') return '';

    const normalized = subActivity.trim().toLowerCase();
    return subActivityClassMap[normalized] || 'default';
  };

  useEffect(() => {
    if (taskId) {
      getTimeSheetLogListByTaskId(taskId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskId, onSuccess]);


  useEffect(() => {
    if (isdeleteTimesheetDetailSuccess && deleteTimesheetDetailData) {
      ToastService.success(deleteTimesheetDetailData.errorMessage);
      getTimeSheetLogListByTaskId(taskId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isdeleteTimesheetDetailSuccess, deleteTimesheetDetailData]);


  useEffect(() => {
    if (
      isGetTimeSheetLogListByTaskIdSuccess &&
      !isGetTimeSheetLogListByTaskIdFetching &&
      isGetTimeSheetLogListByTaskIdData
    ) {
      if (isGetTimeSheetLogListByTaskIdData) {
        const newlist = isGetTimeSheetLogListByTaskIdData?.map((data) => ({
          ...data,
          // startTime: `${data.startTime} - ${data.endTime}`,
        }));
        setListData(newlist);
      }
    }
  }, [
    isGetTimeSheetLogListByTaskIdSuccess,
    isGetTimeSheetLogListByTaskIdFetching,
    isGetTimeSheetLogListByTaskIdData,
  ]);

  useImperativeHandle(ref, () => ({
    refreshTimelogs: () => {
      if (ref) {
        getTimeSheetLogListByTaskId(taskId);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [])

  return (
    <div>
      <div className="time-log">
        <div className="time-log-container">
          <div className="timeline">
            {listData.map((data, index) => (
              <div className="timeline-body" key={index + 1}>
                <div className="timeline-item">
                  <div className="sub-activity" id={`tooltip-top-${index}`}>
                    <Tooltip
                      label={data.activityName}
                      targetId={`tooltip-top-${index}`}
                      position="right"
                      className="time-log-tooltip"
                    />
                  </div>

                  <div className="timeline-time">
                    {data.startTime && formatTime(data.startTime, "HH:mm A")} <span className="time-line">|</span>{" "}
                    {data.endTime && formatTime(data.endTime, "HH:mm A")}
                  </div>
                  <div className={`timeline-content ${generateSubActivityColor(data.subActivityName)}`}>
                    <div className="timeline-content-container">
                      <p className="description">{data.workDescription}</p>
                    </div>
                    <div className="Timelog-edit-delete">
                      <p className="end-date">
                        {data.createdBy},{" "}
                        {data.workAt && formatDate(data.workAt, "DD/MM/YYYY")}
                      </p>
                      <div className="timelog-action">
                        <button onClick={() => handleEditClick(data)}>
                          <Iconify className="edit" icon="line-md:pencil" width="20px" />

                        </button>
                        <button onClick={() => handleDeleteClick(data.timesheetDetailId)}>
                          <Iconify className="delet" icon="mingcute:delete-2-line" width="20px" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <CenterModel
        showModal={modalOpen}
        handleToggleModal={closeModal}
        modalTitle="Edit TimeLog Description"
        modelSizeClass="w-35"
      >
        {/* <EditTimeLogDescription /> */}
        <TaskTimeLog
          isEdit={isEdit}
          editData={editData}
          taskId={taskId}
          projectId={projectId}
          onSuccess={handleSuccess}
        />
      </CenterModel>
    </div>
  );
};

export default forwardRef(TimeLog);
